module.exports = __webpack_public_path__ + "static/namelogo-538820d576473119860282a40395ac77.png";